import { get, post, put } from './https';

export const ToggleToolStatus = async (toolId: string): Promise<string> => {
  const response = await get(`/api/v1/admin/tools/active-inactive/${toolId}`);

  if (response.status == 200) {
    return response.data;
  } else {
    throw new Error(response.statusText || 'Failed to change tool status');
  }
};

export const GetManageTool = async ({
  page = 1,
  limit = 25,
  searchQuery = '',
  sortField = 'name',
  sortOrder = 'ASC',
}: {
  page?: number;
  limit?: number;
  searchQuery?: string;
  sortField?: string;
  sortOrder?: 'ASC' | 'DESC';
}) => {
  let url = `/api/v1/admin/tools/list?limit=${limit}&page=${page}&includeInactive=true`;

  if (searchQuery) {
    url += `&search=${searchQuery}`;
  }

  if (sortField && sortField !== 'name') {
    url += `&sortField=${sortField}`;
  }

  if (sortOrder && sortOrder !== 'ASC') {
    url += `&sortOrder=${sortOrder}`;
  }

  const response = await get(url);

  if (response.status == 200) {
    return response.data;
  } else {
    throw new Error('Failed to fetch tool');
  }
};

export const addTool = async ({
  name,
  description,
  image,
  code,
}: {
  name: string;
  description: string;
  image: any;
  code?: string;
}) => {
  const payload = {
    name,
    description,
    image,
    ...(code ? { code } : {}),
  };

  console.log('payload', payload);

  const response = await post('/api/v1/admin/tools/create', payload);

  if (response.status === 201) {
    return response;
  } else {
    throw new Error(response.statusText || 'Failed to add tool');
  }
};

export const editTool = async ({
  name,
  description,
  image,
  toolId,
  code,
}: {
  name: string;
  description: string;
  image: any;
  toolId: string;
  code?: string;
}) => {
  const payload = {
    name,
    description,
    image,
    toolId,
    ...(code ? { code } : {}),
  };

  const response = await put('/api/v1/admin/tools/edit', payload);
  console.log('response', response);

  if (response.status) {
    return response;
  } else {
    throw new Error(response.statusText || 'Failed to edit tool');
  }
};
